import Service, { service } from '@ember/service';
import { queryManager } from 'ember-apollo-client';
import { task } from 'ember-concurrency';
import sanitize from 'my-phorest/utils/sanitize';

import printingDeviceQuery from 'my-phorest/gql/queries/printing-device.graphql';
import printingDevicesQuery from 'my-phorest/gql/queries/printing-devices.graphql';

export default class PrintingDevicesService extends Service {
  @queryManager apollo;
  @service errorHandler;
  @service intl;
  @service notifications;
  @service session;

  @task
  *fetchPrintingDeviceByIdTask(id) {
    return yield this.apollo.query(
      {
        query: printingDeviceQuery,
        variables: {
          branchId: this.session.currentBranch.id,
          id,
        },
      },
      'printingDevice'
    );
  }

  @task
  *fetchPrintingDevicesTask(variables = {}) {
    return yield this.apollo.query(
      {
        query: printingDevicesQuery,
        variables: {
          branchId: this.session.currentBranch.id,
          ...variables,
        },
        fetchPolicy: 'network-only',
      },
      'printingDevices'
    );
  }

  @task
  *showOpenCashDrawerRequestSentSuccessNotificationTask(id) {
    try {
      const device = yield this.fetchPrintingDeviceByIdTask.perform(id);
      const sanitizedName = sanitize(device.metadata.name);

      this.notifications.success(
        this.intl.t('print.remote-cash-drawer-open-request-sent.title'),
        this.intl.t('print.remote-cash-drawer-open-request-sent.description', {
          name: sanitizedName,
          htmlSafe: true,
        })
      );
    } catch (error) {
      this.errorHandler.handle(error, { showError: false });
    }
  }

  @task
  *showPrintRequestSentSuccessNotificationTask(id) {
    try {
      const device = yield this.fetchPrintingDeviceByIdTask.perform(id);
      const name = `${device.metadata.name} [${device.metadata.printerName}]`;
      const sanitizedName = sanitize(name);

      this.notifications.success(
        this.intl.t('print.remote-printing-request-sent.title'),
        this.intl.t('print.remote-printing-request-sent.description', {
          name: sanitizedName,
          htmlSafe: true,
        })
      );
    } catch (error) {
      this.errorHandler.handle(error, { showError: false });
    }
  }
}
